<style scoped lang="scss">
    .form-autocomplete input {
        padding-left: 50px !important;
    }
</style>

<template>
    <div class="uk-container" v-if="project">
        <ValidationObserver
                v-slot="{ handleSubmit, invalid, dirty }"
                ref="inviteForm"
        >
            <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off">
                <div class="uk-grid">
                    <div class="uk-width-1-1 uk-margin-large-bottom">
                        <h2>Invite Users to Manage "{{ project.project_name }}" Project</h2>
                    </div>

                    <div class="uk-width-1-1 uk-margin-large-bottom" v-for="(user, idx) in users">
                        <div class="uk-grid">
                            <div class="uk-width-1-3">
                                <TextInput
                                        v-model="user.first_name"
                                        label="First Name"
                                        name="First Name"
                                        placeholder="First Name"
                                        :rules="!user.existing ? 'required' : null"
                                        :disabled="user.existing"
                                />
                            </div>
                            <div class="uk-width-1-3">
                                <TextInput
                                        v-model="user.last_name"
                                        label="Last Name"
                                        name="Last Name"
                                        placeholder="Last Name"
                                        :rules="!user.existing ? 'required' : null"
                                        :disabled="user.existing"
                                />
                            </div>
                            <div class="uk-width-1-3">
                                <phone-number-input
                                        name="Phone Number"
                                        label="Phone Number"
                                        v-model="user.phone_number"
                                        :allowValidation="!user.existing ? true : false"
                                        :rules="!user.existing ? 'required' : null"
                                        :disabled="user.existing"
                                ></phone-number-input>
                            </div>
                            <div class="uk-width-1-3">
                                <TextInput
                                        v-model="user.email"
                                        type="email"
                                        label="Email"
                                        name="Email"
                                        placeholder="Email"
                                        :disabled="true"
                                />
                            </div>
                            <div class="uk-width-1-3">
                                <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="User Role"
                                        :vid="vid"
                                >
                                    <p class="uk-margin-bottom-remove"><small>&nbsp;Role</small></p>
                                    <select
                                            class="uk-form-large uk-width-1-1"
                                            :class="{
                                            'uk-form-danger': errors.length
                                        }"
                                            placeholder="User Role"
                                            v-model="user.role_id"
                                    >
                                        <option :value="null">Select a User Role...</option>
                                        <option v-for="role in roles" :value="role.id">{{ role.role_name }}</option>
                                    </select>
                                    <span v-show="errors.length" class="error">{{ errors[0] }}</span>
                                </validation-provider>
                            </div>
                            <div class="uk-width-1-3">
                                <button class="uk-button uk-button-danger uk-margin-top uk-width-1-1" @click="removeUser(idx)">Remove User</button>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-1-1 uk-margin-top uk-margin-large-bottom">
                        <button class="uk-button uk-button-primary" @click="onClickAddUser">Add User</button>
                    </div>
                </div>
            </form>
        </ValidationObserver>
        <user-select
                ref="userSelectModal"
                :source="source"
                @on-select="onSelectUser"
                @on-add="onAddUser"
        ></user-select>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ValidatedSection from "../../../components/Common/ValidatedSection";
    import UserSelect from "../../../../dashboard/components/Common/UserSelect";

    export default {
        name: "InviteLandlordUsers",
        props: {
            source: {
                type: String,
                default: 'property-wizard'
            }
        },
        components: {
            ValidatedSection,
            UserSelect
        },
        data() {
            return {
                errors: {},
                users: [],
            }
        },
        computed: {
            ...mapState('Project', {
                project: state => state.project,
                roles: state => state.roles,
            }),
            ...mapState('Landlord', {
                confirmation: state => state.confirmation,
            })
        },
        mounted() {
        },
        methods: {
            reset() {
                this.users = []
            },
            onClickAddUser() {
                this.$refs.userSelectModal.openModal();
            },

            onAddUser(email) {
                this.users.push({
                    existing: false,
                    user_id: undefined,
                    first_name: '',
                    last_name: '',
                    phone_number: '',
                    email,
                    role_id: null,
                })
            },

            onSelectUser(user) {
                this.users.push({
                    existing: true,
                    user_id: user ? user.id : null,
                    first_name: user ? user.first_name : '',
                    last_name: user ? user.last_name : '',
                    phone_number: user ? user.phone : '',
                    email: user.email ,
                    role_id: null,
                })
            },


            removeUser(idx) {
                this.users.splice(idx, 1);
            },

            async validateStep() {
                let stepValid = false

                await this.$refs.inviteForm.validate().then(async (isValid) => {
                    if (isValid) {
                        stepValid = await this.save()
                    }
                })
                return stepValid
            },

            async save() {
                this.$emit('loading', true)
                let data = {
                    users: this.users,
                    project_id: this.project.id,
                }

                try {
                    let r = await axios.post(`/api/landlord/${this.confirmation.id}/invite-users`, data);
                    this.$emit('loading', false)
                    return true;
                }catch(e) {
                    this.$emit('loading', false)
                    return false;
                }

            },

            vid() {
                return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
            }
        }
    }
</script>
